var _rect, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLandingInstagram(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 47,
    height: 46,
    viewBox: "0 0 47 46",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.426109,
    y: 0.0126953,
    width: 45.9873,
    height: 45.9873,
    rx: 4,
    fill: "#F1F1F1"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.9229 23.0066C11.9229 18.4141 11.9229 16.1178 13.0172 14.4639C13.5059 13.7253 14.1384 13.0928 14.877 12.6041C16.5309 11.5098 18.8272 11.5098 23.4197 11.5098C28.0122 11.5098 30.3085 11.5098 31.9624 12.6041C32.701 13.0928 33.3335 13.7253 33.8221 14.4639C34.9165 16.1178 34.9165 18.4141 34.9165 23.0066C34.9165 27.5991 34.9165 29.8954 33.8221 31.5493C33.3335 32.2879 32.701 32.9204 31.9624 33.4091C30.3085 34.5034 28.0122 34.5034 23.4197 34.5034C18.8272 34.5034 16.5309 34.5034 14.877 33.4091C14.1384 32.9204 13.5059 32.2879 13.0172 31.5493C11.9229 29.8954 11.9229 27.5991 11.9229 23.0066ZM29.3716 23.0072C29.3716 26.2944 26.7067 28.9593 23.4195 28.9593C20.1323 28.9593 17.4675 26.2944 17.4675 23.0072C17.4675 19.72 20.1323 17.0552 23.4195 17.0552C26.7067 17.0552 29.3716 19.72 29.3716 23.0072ZM23.4195 26.9455C25.5946 26.9455 27.3578 25.1823 27.3578 23.0072C27.3578 20.8321 25.5946 19.0689 23.4195 19.0689C21.2444 19.0689 19.4812 20.8321 19.4812 23.0072C19.4812 25.1823 21.2444 26.9455 23.4195 26.9455ZM29.6066 18.1544C30.379 18.1544 31.0051 17.5283 31.0051 16.7559C31.0051 15.9835 30.379 15.3573 29.6066 15.3573C28.8342 15.3573 28.208 15.9835 28.208 16.7559C28.208 17.5283 28.8342 18.1544 29.6066 18.1544Z",
    fill: "#545454"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLandingInstagram);
export default __webpack_public_path__ + "static/media/landingInstagram.1368f731fb248dc41b62f93a4ccc65ea.svg";
export { ForwardRef as ReactComponent };